'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import FlowWaypoints from '../fx/FlowWaypoints'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--collection'
        this.$btnBack = this.view.querySelector('.jsBack--url')
        // Fns
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        this.waypoints.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        if(this.$btnBack != null) {
            this.getUrl = this.$btnBack.getAttribute('data-href')
            Env.$btnBackUI.setAttribute('href',this.getUrl)
        } else {
            Env.$btnBackUI.classList.add('is--hidden')
        }
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $title = this.view.querySelector('.brand .h2')
        const $summary = this.view.querySelector('.works-summary')
        let $itemLeft,$itemRight;
        if(Env.mobileCSS == true) {
            $itemLeft = this.view.querySelector('.collection--touch .jsItem:nth-child(1)')
            $itemRight = this.view.querySelector('.collection--touch .jsItem:nth-child(2)')
        } else {
            $itemLeft = this.view.querySelector('.collection .cell:nth-child(1) .jsItem')
            $itemRight = this.view.querySelector('.collection .cell:nth-child(2) .jsItem')
        }


        tl.add([
            TweenLite.fromTo($title , .8 , { opacity : 0 , y : 30 } , { opacity : 1, y : 0 , ease : Power4.easeOut }),
            TweenLite.fromTo(Env.$btnBackUI , .8 , { opacity : 0 } , { opacity : 1, ease : Cubic.easeOut , onComplete:()=>{
                    TweenLite.set(Env.$btnBackUI , { clearProps : "opacity"})
                    Env.$btnBackUI.classList.add('is--ready')
                }
            }),
        ])
        if($summary != null) {
            tl.add([
                TweenLite.fromTo($summary , .8 , { opacity : 0 , y : 40 } , { opacity : 1, y : 0 , ease : Power4.easeOut , delay : .1 }),
            ],'-=.8')
        }
        tl.add(()=>{
            if($itemLeft != null) {
                $itemLeft.classList.add('is--shown')
            }
            setTimeout(() => {
                if($itemRight != null) {
                    $itemRight.classList.add('is--shown')
                }
            }, 100);
        },'-=.6')
    }

}

page = Barba.BaseView.extend({
    namespace: 'collection',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/collection.js